import React from "react";
import { Text, type ChakraProps, type BoxProps } from "@chakra-ui/react";
import { textStyles } from "theme/text-styles";

type BadgeProps = {
  bg?: ChakraProps["bg"];
  color?: ChakraProps["color"];
} & BoxProps;

export function Badge({ bg = "base.border", color = "text.primary", children, ...props }: BadgeProps & BoxProps) {
  return (
    <Text
      as="span"
      {...textStyles.caption2}
      bg={bg}
      borderRadius="smallest"
      color={color}
      fontWeight="semibold"
      p="tiny"
      sx={{
        "&::first-letter": { textTransform: "capitalize" },
      }}
      {...props}
    >
      {children}
    </Text>
  );
}
